module.exports = __webpack_public_path__ + "img/notification-panel-mobile.676810cb.jpg";